import { render } from "./UNSC.vue?vue&type=template&id=71594d59&scoped=true"
import script from "./UNSC.vue?vue&type=script&lang=js"
export * from "./UNSC.vue?vue&type=script&lang=js"

import "./UNSC.vue?vue&type=style&index=0&id=71594d59&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71594d59"

export default script